import { useMutation, useQuery } from "@apollo/client";
import {
  GetAseobiQuery,
  GetAseobiQueryVariables,
  IsInvitedToEventQuery,
  IsInvitedToEventQueryVariables,
  SignupByInviteLinkMutation,
  SignupByInviteLinkMutationVariables,
} from "@src/@types/api.d";
import { IHome } from "@src/components/Home";
import { SignUpByInviteLink } from "@src/graphql/mutations";
import { GetAsoEbi, IsInvitedToEvent } from "@src/graphql/queries";
import { getCookie } from "cookies-next";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

type UseHomeInput = Pick<
  IHome,
  "eventBySlugData" | "eventUuid" | "inviteResult"
> &
  Partial<IHome>;

export const useHome = ({
  eventBySlugData,
  eventUuid,
  eventId,
  inviteResult,
}: UseHomeInput) => {
  const inviteToken = getCookie("invtk") as string;
  const [accessToken, setAccessToken] = React.useState<string | null>(null);

  useEffect(() => {
    const accessToken = getCookie("tsl") as string;
    if (accessToken) {
      setAccessToken(accessToken);
    }
  }, []);

  const [openAsoebi, setOpenAsoebi] = useState<boolean>(false);

  const [isCashGiftSetup, setIsCashGiftSetup] = React.useState(false);

  const { data: isInvitedToEventData } = useQuery<
    IsInvitedToEventQuery,
    IsInvitedToEventQueryVariables
  >(IsInvitedToEvent, {
    variables: { eventId: eventUuid ?? "" },
    skip: !accessToken || !eventUuid,
  });

  const [signUpByInviteLinkFn] = useMutation<
    SignupByInviteLinkMutation,
    SignupByInviteLinkMutationVariables
  >(SignUpByInviteLink, {
    onError: (error) => {
      // toast.error(
      //   <p className="font-inter">
      //     {error?.message ?? "Error signing up with invite link"}
      //   </p>
      // );
      // console.log(error);
      return;
    },
  });

  useEffect(() => {
    signUpByInviteLinkFn({
      variables: {
        eventId: eventId ?? 0,
        inviteToken,
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inviteResult, eventUuid]);

  const isInvitedToEventValue = isInvitedToEventData?.isInvitedToEvent ?? false;

  const { data: getAsoebiData } = useQuery<
    GetAseobiQuery,
    GetAseobiQueryVariables
  >(GetAsoEbi, {
    variables: { event_id: eventUuid ?? "" },
    skip: !accessToken || !eventUuid || !isInvitedToEventValue,
  });

  React.useEffect(() => {
    setIsCashGiftSetup(
      (eventBySlugData?.eventBySlug?.available_gift_payment_currencies
        ?.length ?? 0) > 0
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    accessToken,
    inviteResult: inviteResult as SignupByInviteLinkMutation | null | undefined,
    getAsoebiData: getAsoebiData ?? undefined,
    openAsoebi,
    setOpenAsoebi,
    isCashGiftSetup,
    setIsCashGiftSetup,
    isInvitedToEvent: isInvitedToEventValue,
  };
};
